import Image from 'next/image';
import registerCompanyImg from '@/assets/img/register-company.svg';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material';

interface IHomeProps {
  nextStep: () => void;
}

export const Home = ({ nextStep }: IHomeProps) => {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <>
      <Box
        sx={{
          marginBottom: '18px',
          height: '215px',
          position: 'relative',
          marginTop: '92px',
        }}
      >
        <Image
          layout="fill"
          src={registerCompanyImg}
          alt="Image de illustração no modal de configurar a empresa"
        />
      </Box>

      <Box textAlign="center">
        <Typography variant="h6" component="h1">
          Vamos configurar sua empresa!
        </Typography>
        <Typography variant="body2" sx={{ opacity: '50%' }}>
          Vamos configurar sua empresa com alguns dados mais específicos.
        </Typography>
      </Box>

      <Box
        sx={{
          width: mdUp ? '390px' : '100%',
          margin: '0 auto',
          marginTop: mdUp ? 5 : 'auto',
        }}
      >
        <Button
          fullWidth
          data-testid="button-next-step"
          variant="contained"
          sx={{ marginTop: 'auto' }}
          onClick={nextStep}
        >
          Quero configurar
        </Button>
      </Box>
    </>
  );
};
